<script>
  import BarChart from './BarChart.svelte';
  import Toggle from '../Toggle.svelte';
  import { __ } from '../../utils/i18n';
  import { dateParser } from '../../utils/d3-utils';

  export let data;
  export let globalMax;
  export let labelUnit;
  export let getChartTitle;
  export let locale = 'en';

  let attribute = 'confirmed_and_probable_cases';
  const attributeButtons = [
    { label: __('Cases'), value: 'confirmed_and_probable_cases' },
    { label: __('Deaths'), value: 'confirmed_deaths' },
  ];
  const handleAttributeClick = (e) => {
    attribute = e.target.getAttribute('data-value');
  };

  let adjustment = 'per_100k';
  const adjustmentButtons = [
    { label: __('Per 100k'), value: 'per_100k' },
    { label: __('Totals'), value: 'total' },
  ];
  const handleAdjustmentClick = (e) => {
    adjustment = e.target.getAttribute('data-value');
  };

  const getSortedData = (attr, adj) => {
    const chartData = data.map((d) => {
      d.total = d[`new_${attr}_seven_day_${adj}`];

      d.line = d.averages[`new_${attr}_${adj}`];
      d.bars =
        d[`new_${attr}_${adj == 'per_100k' ? 'per_100k' : 'timeseries'}`];
      d.maxBar = globalMax[`new_${attr}_${adj}`];

      d.lineStroke = attr == 'confirmed_and_probable_cases' ? '#3894b7' : '#829db0';
      d.barFill = attr == 'confirmed_and_probable_cases' ? '#85B8C6' : '#829db0';
      d.annotation = attr == 'confirmed_and_probable_cases' ? 'cases' : 'deaths';
      d.annotation += adj == 'per_100k' ? ' per 100k' : '';
      d.maxDate = dateParser(d.max_date);
      return d;
    });
    chartData.sort(
      (a, b) =>
        b[`new_${attr}_seven_day_${adj}`] - a[`new_${attr}_seven_day_${adj}`]
    );
    return chartData;
  };
  $: sortedData = getSortedData(attribute, adjustment);

  const labels = {
    confirmed_and_probable_cases: {
      per_100k: `${labelUnit} ranked by new <span class="new-cases-underline">cases</span> per 100,000 residents`,
      total: `${labelUnit} ranked by new <span class="new-cases-underline">cases</span>`,
    },
    confirmed_deaths: {
      per_100k: `${labelUnit} ranked by <span class="deaths-underline">deaths</span> per 100,000 residents`,
      total: `${labelUnit} ranked by <span class="deaths-underline">deaths</span>`,
    },
  };
  const getChartLabel = (attr, adj) => {
    return labels[attr][adj];
  };
  $: chartLabel = getChartLabel(attribute, adjustment);

  let showAll = false;
  let limit = 10;
</script>

<div class="chart-head chart-head--hotspots">
  <div class="button-grid counties-compare-controls">
    <div class="button-grid-group">
      <Toggle
        label={__('Metric')}
        slug="counties-compare-metric"
        buttonList={attributeButtons}
        selectedValue={attribute}
        on:click={handleAttributeClick}
      />
    </div>
    <div class="button-grid-group">
      <Toggle
        label={__('Method')}
        slug="counties-compare-adjustment"
        buttonList={adjustmentButtons}
        selectedValue={adjustment}
        on:click={handleAdjustmentClick}
      />
    </div>
  </div>
  <div class="chart-head--label" style="margin-top: 20px;">
    {@html __(chartLabel)}
  </div>
</div>

<div class="counties-compare-container">
  {#each sortedData as obj, idx}
    <div
      class="county-small-chart"
      data-idx={idx}
      data-name={obj.county}
      data-seven-day-average-per-100k={obj.new_confirmed_and_probable_cases_seven_day_per_100k}
      class:display-none={idx + 1 > limit && !showAll}
    >
      <div class="small-chart-label">
        <div class="small-chart-label--headline">
          {@html getChartTitle(obj, idx)}
        </div>
      </div>
      <BarChart
        bind:bars={obj.bars}
        bind:barFill={obj.barFill}
        bind:line={obj.line}
        bind:lineStroke={obj.lineStroke}
        bind:globalMax={obj.maxBar}
        bind:maxDate={obj.maxDate}
        showXAxisLabels={idx == 0}
        bind:annotation={obj.annotation}
        showAnnotations={idx == 0}
        bind:total={obj.total}
        {locale}
      />
    </div>
  {/each}
</div>
{#if sortedData.length > limit}
  <div class="text-center">
    <button class="btn" on:click={() => (showAll = !showAll)}>
      {showAll ? __('Show less') : __('Show all')}
    </button>
  </div>
{/if}
